/**
 * Accordion Component JavaScript
 * Handles accordion functionality for collapsible content
 */

class Accordion {
    constructor(element) {
      this.accordion = element;
      this.trigger = this.accordion.querySelector('.accordion__trigger');
      this.content = this.accordion.querySelector('.accordion__content');
      this.icon = this.accordion.querySelector('.accordion__icon-svg');
      
      // Get the group container (look for parent with accordion-group class)
      this.group = this.accordion.closest('.accordion-group');
      
      this.init();
    }
  
    init() {
      if (!this.trigger || !this.content) {
        return;
      }
      
      this.setupEventListeners();
    }
  
    setupEventListeners() {
      this.trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggle();
      });
    }
  
    toggle() {
      const isExpanded = this.trigger.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        this.close();
      } else {
        this.open();
      }
    }
  
    open() {
      // Close other accordions in the same group first
      this.closeOtherAccordions();
      
      this.trigger.setAttribute('aria-expanded', 'true');
      this.content.removeAttribute('hidden');
      this.content.style.height = this.content.scrollHeight + 'px';
      if (this.icon) {
        this.icon.style.transform = 'rotate(180deg)';
      }
      
      // Remove height after animation
      setTimeout(() => {
        this.content.style.height = 'auto';
      }, 300);
    }
  
    close() {
      this.trigger.setAttribute('aria-expanded', 'false');
      this.content.style.height = this.content.scrollHeight + 'px';
      
      // Force reflow
      this.content.offsetHeight;
      
      this.content.style.height = '0px';
      if (this.icon) {
        this.icon.style.transform = 'rotate(0deg)';
      }
      
      // Hide after animation
      setTimeout(() => {
        this.content.setAttribute('hidden', '');
        this.content.style.height = '';
      }, 300);
    }
  
    // New method to close other accordions in the same group
    closeOtherAccordions() {
      if (!this.group) return;
      
      // Find all other accordions in the same group
      const otherAccordions = this.group.querySelectorAll('[data-accordion]:not([data-accordion-initialized="false"])');
      
      otherAccordions.forEach(accordion => {
        // Skip this accordion
        if (accordion === this.accordion) return;
        
        // Check if it's open
        const trigger = accordion.querySelector('.accordion__trigger');
        const content = accordion.querySelector('.accordion__content');
        const icon = accordion.querySelector('.accordion__icon-svg');
        
        if (trigger && content && trigger.getAttribute('aria-expanded') === 'true') {
          // Close it
          trigger.setAttribute('aria-expanded', 'false');
          content.style.height = content.scrollHeight + 'px';
          
          // Force reflow
          content.offsetHeight;
          
          content.style.height = '0px';
          if (icon) {
            icon.style.transform = 'rotate(0deg)';
          }
          
          // Hide after animation
          setTimeout(() => {
            content.setAttribute('hidden', '');
            content.style.height = '';
          }, 300);
        }
      });
    }
  }
  
  // Function to initialize all accordions
  function initializeAccordions() {
    const accordions = document.querySelectorAll('[data-accordion]:not([data-accordion-initialized])');
    accordions.forEach(accordion => {
      new Accordion(accordion);
      accordion.setAttribute('data-accordion-initialized', 'true');
    });
  }
  
  // Initialize now if DOM is already ready (idle/lazy script load),
  // otherwise wait for DOMContentLoaded (defer script on product pages).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAccordions);
  } else {
    initializeAccordions();
  }
  
  // Re-initialize accordions when new content is added (for dynamic content)
  if (typeof window !== 'undefined') {
    window.initializeAccordions = initializeAccordions;
  }
  
  // Export for module usage
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Accordion;
  }